/*
 * @Author: weiShu
 * @Date: 2025-12-29 15:40:44
 * @LastEditors: weiShu
 * @LastEditTime: 2026-04-24 10:36:40
 * @FilePath: \health-commission-new-2\src\api\index.js
 * @Description: 
 */
import request from '@/utils/server.js'


export function userLogin(data) {
    return request({
        url: `/user/login`,
        method: 'post',
        data: data
    })
}

/** 微信登录：获取微信 OAuth 授权页 URL */
export function wxLogin(data) {
    return request({
        url: `/wx/wxLogin`,
        method: 'post',
        data: data || {}
    })
}

/** 临时 token：POST /wx/getToken */
export function getWxToken(data) {
    return request({
        url: `/wx/getToken`,
        method: 'post',
        data: data || {}
    })
}

/** 补考 JSAPI 订单：POST /wx/createBKOrder */
export function createBKOrder(data) {
    return request({
        url: `/wx/createBKOrder`,
        method: 'post',
        data: data || {},
    })
}

/** 查询支付状态：POST /wx/getPayState */
export function getPayState(data) {
    return request({
        url: `/wx/getPayState`,
        method: 'post',
        data: data || {},
        silentToast: true,
    })
}

export function getLoginInfo() {
    return request({
        url: `/user/loginInfo`,
        method: 'get'
    })
}

export function getMyToBeTested(data) {
    return request({
        url: `/exam/getMyToBeTested`,
        method: 'post',
        data: data
    })
}

/** 开始模拟考试（免费通道） */
export function getPracticeTest() {
    return request({
        url: `/exam/practiceTest`,
        method: 'get'
    })
}

export function getTopics(testPaperId) {
    return request({
        url: `/exam/getTopics/${testPaperId}`,
        method: 'get'
    })
}

export function submitAnswer(data) {
    return request({
        url: `/exam/answer`,
        method: 'post',
        data: data
    })
}

export function uploadImage(file) {
    return request({
        url: `/upload/uploadImage`,
        method: 'post',
        formData: {
            file: file
        }
    })
}

export function submitExam(data) {
    return request({
        url: `/exam/theResponding`,
        method: 'post',
        data: data
    })
}

export function getMyAnswers(data) {
    return request({
        url: `/exam/getMyAnswers`,
        method: 'post',
        data: data
    })
}

export function startQuiz(testPaperId) {
    return request({
        url: `/exam/startQuiz/${testPaperId}`,
        method: 'get'
    })
}

export function getCertificateInfo(answerId) {
    return request({
        url: `/exam/getCertificateInfo/${answerId}`,
        method: 'get'
    })
}

export function getTrainList() {
    return request({
        url: `/exam/getTrainList`,
        method: 'get'
    })
}

export function editorUser(data) {
    return request({
        url: `/exam/editorUser`,
        method: 'post',
        data: data
    })
}

export function getCertificate(answerId) {
    return request({
        url: `/exam/getCertificate/${answerId}`,
        method: 'get'
    })
}

export function getTestPaperInfo(answerId) {
    return request({
        url: `/exam/getTestPaperInfo/${answerId}`,
        method: 'get'
    })
}

export function getTW(data) {
    return request({
        url: `/h5/getTW`,
        method: 'post',
        data: data
    })
}

/** 图形验证码：GET /captcha/get */
export function getCaptcha() {
    return request({
        url: `/captcha/get`,
        method: 'get',
    })
}

/** 账号信息绑定：POST /h5/accountBinding */
export function accountBinding(data) {
    return request({
        url: `/h5/accountBinding`,
        method: 'post',
        data: data,
    })
}

/** 轮播图列表：POST /h5/bannerList */
export function getBannerList(data) {
    return request({
        url: `/h5/bannerList`,
        method: 'post',
        data: data || {}
    })
}

/** 课程分类列表：POST /h5/courseTypeList */
export function getCourseTypeList(data) {
    return request({
        url: `/h5/courseTypeList`,
        method: 'post',
        data: data || {}
    })
}

/** 课程列表：POST /h5/getCourseList */
export function getCourseList(data) {
    return request({
        url: `/h5/getCourseList`,
        method: 'post',
        data: data || {}
    })
}

/** 完成图文阅读：GET /h5/finishedReading/{knowledgeLearningId} */
export function finishedReading(knowledgeLearningId) {
    return request({
        url: `/h5/finishedReading/${knowledgeLearningId}`,
        method: 'get'
    })
}

/** 图文详情：GET /h5/getTwInfo/{id} */
export function getTwInfo(id) {
    return request({
        url: `/h5/getTwInfo/${id}`,
        method: 'get'
    })
}

/** 完成课程培训：GET /h5/finishedTrain/{courseId} */
export function finishedTrain(courseId) {
    return request({
        url: `/h5/finishedTrain/${courseId}`,
        method: 'get'
    })
}

/** 课程详情：GET /h5/getCourseInfo/{courseId} */
export function getCourseInfo(courseId) {
    return request({
        url: `/h5/getCourseInfo/${courseId}`,
        method: 'get'
    })
}

/** 获取选修课数量：GET /h5/getElectiveNum */
export function getElectiveNum() {
    return request({
        url: `/h5/getElectiveNum`,
        method: 'get'
    })
}

/** 我的订单：POST /h5/getPayOrder */
export function getPayOrder(data) {
    return request({
        url: `/h5/getPayOrder`,
        method: 'post',
        data: data || {}
    })
}

/** 个人剂量列表：POST /h5/getPersonalDose */
export function getPersonalDose(data) {
    return request({
        url: `/h5/getPersonalDose`,
        method: 'post',
        data: data || {}
    })
}

/** 健康报告列表：POST /h5/getHealthReports */
export function getHealthReports(data) {
    return request({
        url: `/h5/getHealthReports`,
        method: 'post',
        data: data || {}
    })
}
